module.exports = __webpack_public_path__ + "static/HKGrotesk-MediumItalic-ddb992f3f7419760753fe28a60d56004.woff2";